module.exports = __webpack_public_path__ + "static/media/After -B@2x.3bda1def.jpg";